/**
 * 策略上下文：默认策略 + @app 应用层覆写
 * 1:1 还原参考项目 @pkg/diffconfig/src/diffStrategy.js
 */
import appStrategies from '@app/config/strategy'
import standardStrategies from './config/strategy'
import { validateOverrides } from './validateOverrides'

validateOverrides('strategy', standardStrategies, appStrategies)

const strategies = { ...standardStrategies, ...appStrategies }
export default strategies
